import React, { useEffect, useMemo, useState } from 'react';
import { Box, Flex, Grid, Input, Link, Text, useDisclosure } from '@chakra-ui/react';
import { useBlockchainProvider } from '../../../providers/Blockchain/blockchainProvider';
import { ButtonBuy, ButtonPlay } from '../../../components/GamePurchasePane/button';
import { BigNumber, ethers } from 'ethers';
import { PanelGroup } from '../Body/panelGroup';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { DeploymentOverlay } from './DeploymentOverlay/deploymentOverlay';
import { createStandaloneToast } from '@chakra-ui/react';
import { useReflink } from '../../../providers/Reflink/useReflink';
import { emptyGame, IGame } from 'src/providers/Games/useGames';
import { Network } from '../../../providers/Networks/useNetworks';
import { blockchainConfig } from '../../../blockchain-config';
import { useMoralisQuery } from 'react-moralis';
import { AirdropInfo } from 'src/pages/GameOverview/GetGame/AirdropInfo/airdropInfo';
import { useGameUserProvider } from '../../../providers/GameUser/gameUserProvider';
import { formatCartridge } from 'src/utils/parser';
import { CARTRIDGE_ABI, DEPRECATED_STORE_API, STORE_ABI, TOKEN_ABI } from './abis';
import { nFormatter } from 'src/utils/utils';
import { Agreement } from './Agreement/agreement';
import { Reflink } from './Reflink/reflink';
import { BalanceItem } from './BalanceItem/balanceItem';
import { TransactionLoadingBar } from './TransactionLoadingBar/transactionLoadingBar';
import { FirstTimeButtons } from './FirstTimeButtons/firstTimeButtons';
import useAsyncEffect from '../../../utils/hooks/effects/async';

export enum BuyStages {
	NOT_STARTED,
	APPROVING,
	APPROVED,
	BUYING,
	BOUGHT,
}

const MAX_BUYABLE_COPIES = 4200;

export const GetGame = ({
	isOwned,
	id,
	url,
	iconUrl,
	game,
}: {
	isOwned: boolean;
	id: string;
	url: string;
	iconUrl: string;
	game: IGame;
}) => {
	const { isEthereum, login, isLoggedIn, signer, account, provider } = useBlockchainProvider();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { toast } = createStandaloneToast();

	const [buyingStage, setBuyingStage] = useState<BuyStages>(BuyStages.NOT_STARTED);
	const [providedGameData, setProvidedGameData] = useState<IGame>(emptyGame);

	const { data, isLoading } = useMoralisQuery('Games', query => query.equalTo('address', id?.toLowerCase()));
	useEffect(() => {
		if (isLoading) {
		} else if (data.length > 0) {
			const payload = (data as any)[0].attributes as IGame;
			setProvidedGameData(payload);
		}
	}, [id, data]);

	const userGame = useGameUserProvider();

	const buyTokenAddress: { [p: number]: string } = {
		[Network.POLYGON_MAINNET]: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
		[Network.MUMBAI_TESTNET]: '0xf583F23e2b26f1ABd88804704E3826DeafC8A21d',
	};
	const buyTokenContract = useMemo(
		() => new ethers.Contract(buyTokenAddress[blockchainConfig.NETWORK_DEFAULT.ID], TOKEN_ABI, signer!),
		[signer]
	);

	const cartridgeContract = useMemo(() => new ethers.Contract(game.address, CARTRIDGE_ABI, signer!), [signer]);

	const [approvalEnough, setApprovalEnough] = useState<boolean>(false);

	useAsyncEffect(async () => {
		if (!game.price) {
			return;
		}

		const isGameInDeprecation = !game.marketplaceFee;
		const approval = await buyTokenContract.allowance(
			account,
			isGameInDeprecation ? deprecatedIgoContract.address : igoContract.address
		);

		// console.log(, "teeest", Number(game.price))

		// console.log('fasdfas', Boolean(BigNumber.from(approval).lte(BigNumber.from(Number(game.price) * MAX_BUYABLE_COPIES).mul('100'))))
		//old if
		//BigNumber.from(approval).lte(BigNumber.from(Number(game.price) * MAX_BUYABLE_COPIES).mul('100'))
		if (Number(parseInt(approval, 16) / 1000) < Number(game.price)) {
			setApprovalEnough(false);
		} else {
			setApprovalEnough(true);
		}
	}, [buyTokenContract, game, account]);

	const deprecatedIgoAddress: { [p: number]: string } = {
		[Network.POLYGON_MAINNET]: '0x9741708b2DeDE32c972D3EF7959Fa3262860E485',
		[Network.MUMBAI_TESTNET]: '0xa455F248ba4475D11043D029d7dc6FD11270B66e',
	};
	const igoAddress: { [p: number]: string } = {
		[Network.POLYGON_MAINNET]: '0x1aFb90451aBbF5Eb6f59842CAF8949374F1B4683',
		[Network.MUMBAI_TESTNET]: '0xFeddE591f50d9de05A39609E479Dd65bc85A1112',
	};
	const deprecatedIgoContract = useMemo(
		() =>
			new ethers.Contract(
				deprecatedIgoAddress[blockchainConfig.NETWORK_DEFAULT.ID],
				DEPRECATED_STORE_API,
				signer!
			),
		[signer]
	);
	const igoContract = useMemo(
		() => new ethers.Contract(igoAddress[blockchainConfig.NETWORK_DEFAULT.ID], STORE_ABI, signer!),
		[signer]
	);

	const [amountToBuy, setAmountToBuy] = useState(1);
	const handleAmountChange = (e: any) => {
		//console.log('amount', e.target.value);
		if (e.target.value) {
			if (e.target.value.length === 2 && e.target.value[0] === '0') e.target.value = e.target.value[1];
			if (e.target.value > MAX_BUYABLE_COPIES) {
				e.target.value = MAX_BUYABLE_COPIES;
			} else if (e.target.value < 0.01 && e.target.value > 0) {
				e.target.value = 0;
			}
			let number = Number(e.target.value);
			if (e.target.value > 0.01) {
				number = Math.round(number * 100) / 100;
			}

			console.log(number);
			setAmountToBuy(number);
		} else {
			setAmountToBuy(0);
		}
	};

	const generateBuyTransaction = async (tokenAddress: string, total: number, deprecationMode: boolean) => {
		console.log('deprecationMode:', deprecationMode);
		console.log((total * 100).toString().replaceAll('.', ''));

		const store = await cartridgeContract.store();

		const broken = store.toLowerCase() != '0x1afb90451abbf5eb6f59842caf8949374f1b4683'.toLowerCase();

		/** Approve fallback */
		// if (!approvalEnough) {
		// 	await handleApprove();
		// }

		const etherCorrection = (total * Number(providedGameData.creatorFee ?? 0)) / 10;
		const etherCorrected = 100 * total + etherCorrection;
		const etherTotal = parseInt(`${etherCorrected + (etherCorrection ? etherCorrected * 0.01 : 0)}`, 10).toString();

		/** HashUp V0 */
		if (deprecationMode) {
			if (reflink.getReflink && reflink.getReflink !== account) {
				return await deprecatedIgoContract['buyCartridge(address,uint256,address)'](
					tokenAddress,
					(total * 100).toString().replaceAll('.', ''),
					reflink.getReflink
				);
			} else {
				return await deprecatedIgoContract['buyCartridge(address,uint256)'](tokenAddress, total.toString());
			}
		}

		/** HashUp V1 */
		const marketplaceAddress = '0x714EF5c429ce9bDD0cAC3631D30474bd04e954Dc';

		return await igoContract['buyLicense(address,uint256,address,address)'](
			tokenAddress,
			broken ? etherTotal : (total * 100).toString().replaceAll('.', ''),
			marketplaceAddress,
			reflink.getReflink || ethers.constants.AddressZero
		);
	};

	const handleApprove = async () => {
		setBuyingStage(BuyStages.APPROVING);

		const isGameInDeprecation = !game.marketplaceFee;
		const approvalTransaction = await buyTokenContract.approve(
			isGameInDeprecation ? deprecatedIgoContract.address : igoContract.address,
			ethers.constants.MaxUint256
		);

		await approvalTransaction.wait();

		console.log('after approve')

		setBuyingStage(BuyStages.APPROVED);
	};

	const handleBuy = async () => {
		const isTermsAgreed = localStorage.getItem('termsAgreed') ?? false;
		if (!isTermsAgreed) {
			onOpen();
			return;
		}

		try {
			const buyTransaction = await generateBuyTransaction(id, amountToBuy, !game.marketplaceFee);
			
			setBuyingStage(BuyStages.BUYING);
			await buyTransaction.wait();
			setBuyingStage(BuyStages.BOUGHT);
			setTimeout(() => setApprovalEnough(true), 2000);

			await (window as any).ethereum.request({
				method: 'wallet_watchAsset',
				params: {
					type: 'ERC20',
					options: {
						address: game.address,
						symbol: game.symbol,
						decimals: 2,
						image: game.media.icon ?? game.media.logoUrl,
					},
				},
			});
		} catch (error) {
			if ((error as any).reason === 'execution reverted: ERC20: transfer amount exceeds balance') {
				toast({ title: `You don't have enough USDC` });
				setBuyingStage(BuyStages.APPROVED);
			}
		}
	};

	const { callToActionColor, callToActionTextColor } = useGameColorsProvider();
	const reflink = useReflink();

	const [usdcBalance, setUsdcBalance] = useState('…');

	useEffect(() => {
		(async () => {
			if (isEthereum && provider && account !== ethers.constants.AddressZero) {
				const ethers = require('ethers');
				const genericErc20Abi = require('../../../contracts/erc20/abi.json');
				const tokenContractAddress = '0x2791bca1f2de4661ed88a30c99a7a9449aa84174';
				try {
					const contract = new ethers.Contract(tokenContractAddress, genericErc20Abi, provider);
					const balance = (await contract.balanceOf(account)).toString();

					if (!isNaN(balance)) {
						setUsdcBalance(ethers.utils.formatUnits(balance, 6));
					}
				} catch {}
			}
		})();
	}, [provider, account]);

	useEffect(() => {
		if (userGame.balance === '0' || BigNumber.from(userGame.balance).gte('100')) {
			return;
		}

		const remainder = BigNumber.from('100').sub(BigNumber.from(userGame.balance));

		setAmountToBuy(Number(ethers.utils.formatUnits(remainder.toString(), 2)));
	}, [userGame.balance]);

	return (
		<Grid
			w="100%"
			gridGap="10px"
		>
			<Agreement
				onClose={onClose}
				isOpen={isOpen}
				handleBuy={handleBuy}
			/>

			{/** @ts-ignore */}
			{isOwned && (
				<ButtonPlay
					as={Link}
					_hover={{ textDecoration: 'none' }}
					href={url}
					flex="875"
				/>
			)}
			<PanelGroup>
				<Grid
					gap="20px"
					position="relative"
				>
					<Flex justifyContent="space-between">
						<Text
							fontFamily="Sora"
							fontWeight="600"
							fontSize="16px"
							userSelect="none"
						>
							Buy this game
						</Text>
						<Reflink id={id} />
					</Flex>
					<Flex
						width="100%"
						justifyContent="space-between"
					>
						<BalanceItem
							value={formatCartridge(ethers.utils.formatUnits(userGame.balance, 2))}
							label="Your cartridges"
							symbol={game.symbol}
						/>
						<BalanceItem
							value={nFormatter(Number(usdcBalance), 3)} //{game.price && nFormatter(Number(usdcBalance), 3)}{' '}
							label="Your balance"
							symbol={'USDC'}
							reverseAlign
						/>
					</Flex>
					<Grid
						templateColumns="140px auto "
						alignItems="center"
					>
						<Grid templateColumns="20px auto 27px">
							<Box
								bg="gray"
								border="1px solid rgba(255,255,255,0.4)"
								borderRadius="50%"
								bgImage={iconUrl}
								bgSize="cover"
								zIndex="1"
								boxSize="40px"
							/>
							<Input
								maxLength={MAX_BUYABLE_COPIES}
								fontSize="16px"
								fontWeight="bold"
								lineHeight="125%"
								type="number"
								name="price"
								pattern="[0-9]+([\.,][0-9]+)?"
								borderRadius="0px"
								borderColor="rgba(255,255,255,0.4)"
								value={amountToBuy}
								placeholder="0"
								_placeholder={{ color: 'red.500' }}
								borderRight="none"
								borderLeft="none"
								textAlign="center"
								onChange={handleAmountChange}
								_focus={{
									boxShadow: 'none !important',
									//border: 'rgba(255,255,255,0.4) solid 1px none !important',
									outline: 'none !important',
								}}
							/>
							<Grid
								overflow="hidden"
								gridTemplateRows="1fr 1fr"
								cursor="pointer"
								fontWeight="bold"
								userSelect="none"
							>
								<Flex
									justify="center"
									align="center"
									onClick={() => {
										if (Number(amountToBuy) >= 1) setAmountToBuy(Number(amountToBuy) + 1);
										else if (amountToBuy < 1 && amountToBuy >= 0.1)
											setAmountToBuy(parseFloat((amountToBuy + 0.1).toFixed(2)));
										else if (amountToBuy < 0.1 && amountToBuy >= 0.01)
											setAmountToBuy(parseFloat((amountToBuy + 0.01).toFixed(2)));
									}}
									bg={callToActionColor}
									color={callToActionTextColor}
									_hover={{ opacity: 0.7 }}
									borderLeftColor=""
									borderRadius="0px 4px 0px 0px"
								>
									+
								</Flex>
								<Flex
									justify="center"
									align="center"
									border="1px solid"
									borderColor="rgba(255,255,255,0.4)"
									_hover={{ borderColor: callToActionColor }}
									borderRadius="0px 0px 4px 0px"
									onClick={() => {
										if (Number(amountToBuy) > 1) setAmountToBuy(Number(amountToBuy) - 1);
										else if (amountToBuy <= 1 && amountToBuy > 0.1)
											setAmountToBuy(parseFloat((amountToBuy - 0.1).toFixed(2)));
										else if (amountToBuy <= 0.1 && amountToBuy > 0.01)
											setAmountToBuy(parseFloat((amountToBuy - 0.01).toFixed(2)));
									}}
								>
									-
								</Flex>
							</Grid>
						</Grid>
						<Flex
							flexDirection="column"
							justifyContent="center"
							alignItems="flex-end"
							overflow="hidden"
						>
							<Box
								opacity=".5"
								userSelect="none"
							>
								Total price
							</Box>
							<Box
								fontSize="16px"
								fontWeight="bold"
								lineHeight="125%"
							>
								{game.price &&
									nFormatter(
										Number(
											ethers.utils.formatUnits(
												BigNumber.from(game.price).mul(Math.floor(amountToBuy * 100)),
												6
											)
										),
										3
									)}{' '}
								<Box
									display="inline-block"
									fontSize="12px"
								>
									USDC
								</Box>
							</Box>
						</Flex>
					</Grid>
					{approvalEnough ? (
						<ButtonBuy
							onClick={isLoggedIn ? handleBuy : login}
							flex="125"
							isVariantSmall={isOwned}
						/>
					) : (
						<FirstTimeButtons
							handleApprove={handleApprove}
							handleBuy={handleBuy}
							stage={buyingStage}
						/>
					)}
					<DeploymentOverlay stage={buyingStage} />
					{!approvalEnough && <TransactionLoadingBar stage={buyingStage} />}
				</Grid>
			</PanelGroup>
			<AirdropInfo
				amount={amountToBuy}
				price={providedGameData.price}
			/>
		</Grid>
	);
};
